import GqlErrors from './GqlErrors'

export default class GqlForm {
    constructor(fields) {
        for (const field in fields) {
            this[field] = fields[field]
        }

        this.errors = new GqlErrors
    }

    fillErrors(errors, refs) {
        return this.errors.set(errors, refs)
    }
}
